<div
  matRipple
  role="button"
  [attr.aria-label]="buttonText"
  class="create-message celo-hoverable celo-cursor-pointer p-3"
>
  @if (!disableIcon) {
    <div class="icon-circle">
      <mat-icon [svgIcon]="'icon-message'"></mat-icon>
    </div>
  }
  <div class="text">{{ buttonText }}</div>
</div>
